import React from 'react';

import { ajax, ProfileLevels, myDeepCopy, setEmptyStrings, loadUsersList } from '../components/globals';
import { Languages } from '../components/languages';

import {
    InputSection
} from '../components/utilities';
import { PageTitle, UserCard, UIMessageBox, UIButton, UIPopup, CurrentPasswordPopup, PasswordPolicyTooltip } from '../components/guiElements';
import {
    emptyValidation, 
    validate
} from '../components/validate';
import UsersList from '../components/usersList';
import { Roles } from "../auth/rolesPermissions";
import { isPasswordValid } from "../auth/passwordPolicy";
import { saveUserContext } from "../auth/sessionService";

// flex align
//https://stackoverflow.com/questions/18744164/flex-box-align-last-row-to-grid

export default class UserProfile extends React.Component {
    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onActionClick = this.onActionClick.bind(this);

        this.saveClick = this.saveClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addUser = this.addUser.bind(this);
        this.toggleUsersListHandler = this.toggleUsersListHandler.bind(this);
        //this.createUser = this.createUser.bind(this);
        this.cancelCreateUser = this.cancelCreateUser.bind(this);
        this.passwordChanged = this.passwordChanged.bind(this);
        this.le = Languages.UserProfile[Languages.selectedLanguage];
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.changeRoleAllowed = false;
        this.emailText = this.le.registration.email;
        if (this.uc.userRole === Roles.WAREHOUSEUSER ||
            this.uc.userRole === Roles.WAREHOUSEADMIN) {
            this.emailText = this.le.registration.userName;
            }

        this.configs = {
            card: { title: this.le.card.title, },
            sections: [
                {
                    id: 'registration',
                    class: 'password-tooltip-section',
                    title: this.le.registration.title,
                    mandatoryMessage: this.le.registration.mandatoryMessage,
                    columns: [{
                        id: 'C1',
                        rowsize: 20,
                        itemunit: 10,
                        items: [
                            { id: 'name', size: 10, text: this.le.registration.name, type: 'text', mandatory: true, ...((this.uc.userRole === Roles.WAREHOUSEUSER || this.uc.userRole === Roles.WAREHOUSEADMIN) && { disabled: true }) },
                            { id: 'surname', size: 10, text: this.le.registration.surname, type: 'text', mandatory: true, ...((this.uc.userRole === Roles.WAREHOUSEUSER || this.uc.userRole === Roles.WAREHOUSEADMIN) && { disabled: true }) },
                            { id: 'password', size: 10, text: this.le.registration.password, type: 'password', class: "password-input-container", mandatory: true, onFocus: () => this.setState({passwordFocused: true}), onBlur: () => this.setState({passwordFocused: false })},
                            { id: 'confirm', size: 10, text: this.le.registration.confirm, type: 'password', mandatory: true },
                            
                            { id: 'phone', size: 10, text: this.le.registration.phone, type: 'tel', mandatory: true, ...((this.uc.userRole === Roles.WAREHOUSEUSER || this.uc.userRole === Roles.WAREHOUSEADMIN) && { disabled: true }) },
                            { id: 'email', size: 10, text: this.emailText, type: 'email', mandatory: true, disabled: true },
                            {
                                id: "recoveryMail", size: 10, text: this.le.recoveryMail.label, type: "email", mandatory: false,  maxLength: 320
                            }
                        ],
                        buttons: [{ type: 'confirm wide', text: this.le.buttons[0], click: this.saveClick }]
                    }]
                },
                {
                    id: 'invoicing',
                    extraClass: 'mango',
                    title: this.le.invoicing.title,
                    invoiceMessage: this.le.invoicing.invoiceMessage,
                    columns: [
                        {
                            id: 'C1',
                            rowsize: 20,
                            itemunit: 10,
                            items: [
                                { id: 'name', size: 10, text: this.le.invoicing.name, type: 'text', mandatory: false,disabled: true  },
                                { id: 'surname', size: 10, text: this.le.invoicing.surname, type: 'text', mandatory: false,disabled: true  },
                                { id: 'businessName', size: 20, text: this.le.invoicing.businessName, type: 'text', mandatory: false,disabled: true  },
                                { id: 'address', size: 20, text: this.le.invoicing.address, type: 'text', mandatory: false,disabled: true  },
                                { id: 'city', size: 20, text: this.le.invoicing.city, type: 'text', mandatory: false,disabled: true  },
                                { id: 'province', size: 10, text: this.le.invoicing.province, type: 'text', mandatory: false, MaxLength: 2,disabled: true  },
                                { id: 'zipCode', size: 10, text: this.le.invoicing.zipCode, type: 'number', mandatory: false,disabled: true  },
                                { id: 'fiscalCode', size: 20, text: this.le.invoicing.fiscalCode, type: 'text', mandatory: false,disabled: true  },

                                { id: 'phone', size: 20, text: this.le.invoicing.phone, type: 'tel', mandatory: false,disabled: true  },
                                { id: 'certEmail', size: 20, text: this.le.invoicing.certEmail, type: 'email', mandatory: false,disabled: true  },
                                //{ id: 'confirm', size: 20, text: this.le.invoicing.confirm, type: 'email', mandatory: false,disabled: true  },
                                { id: 'vatNumber', size: 20, text: this.le.invoicing.vatNumber, type: 'number', mandatory: false,disabled: true  },
                                { id: 'uniqueCode', size: 20, text: this.le.invoicing.uniqueCode, type: 'text', mandatory: false,disabled: true  },
                                { id: 'adminEmail', size: 20, text: this.le.invoicing.adminEmail, type: 'email', mandatory: false,disabled: true  }                               
                            ],
                        }
                    ],
                }
            ]
        };
        
        

        if (this.uc.userRole === Roles.ADMIN) {
            this.configs.sections[0].columns[0].items.push({ id: 'chkAdmin', size: 5, text: this.le.registration.chkAdmin, type: 'radio', group: 'level' });
            this.configs.sections[0].columns[0].items.push({ id: 'chkUser', size: 5, text: this.le.registration.chkUser, type: 'radio', group: 'level' });
            this.configs.sections[0].columns[0].items.push({ id: 'chkReadonly', size: 3, text: this.le.registration.chkReadonly, type: 'radio', group: 'level' });
            this.configs.sections[0].columns[0].items.push({ id: 'chkUserPro', size: 3, text: this.le.registration.chkUserPro, type: 'radio', group: 'level' });
        }


        this.headers = [];

        

        this.headers.push({
            generic: { manage: 0, name: 'name', width: 10, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[0] },
            element: { type: 'input', fieldType: 'text', colClass: null, itemClass: null, options: [] }
        });
        this.headers.push({
            generic: { manage: 0, name: 'surname', width: 7, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[1] },
            element: { type: 'input', fieldType: 'text', colClass: null, itemClass: null, options: null }
        });
        this.headers.push({
            generic: { manage: 0, name: 'password', width: 7, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[2] },
            element: { type: 'input', fieldType: 'password', colClass: null, itemClass: null, options: null, mandatory: true }
        });
        this.headers.push({
            generic: { manage: 0, name: 'confirmPwd', width: 7, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[3] },
            element: { type: 'input', fieldType: 'password', colClass: null, itemClass: null, options: null, mandatory: true }
        });
        this.headers.push({
            generic: { manage: 0, name: 'phone', width: 5, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[4] },
            element: { type: 'input', fieldType: 'text', colClass: null, itemClass: 'upper', options: null }
        });
        this.headers.push({
            generic: { manage: 0, name: 'email', width: 13, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[5] },
            element: { type: 'input', fieldType: 'email', colClass: null, itemClass: null, options: null }
        });
        this.headers.push({
            generic: { manage: 0, name: 'profileType', width: 13, change: this.onFieldChange, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[6] },
            element: { 
                    type: 'select',
                    colClass: null,
                    itemClass: null,
                    options: [
                    {
                        text: 'Admin',
                        value: 'admin'
                    },
                    {
                        text: 'Readonly',
                        value: 'readonly'
                    },
                    {
                        text: 'User',
                        value: 'user'
                    },
                    {
                        text: 'Utente Pro',
                        value: 'userPro'
                    },
                ]
            }
        });
        this.headers.push({
            generic: { manage: 0, name: 'maskedRecoveryMail', width: 13, change: null, click: null },
            caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.usersList.captions[7] },
            element: { type: 'recoveryMail', colClass: null, itemClass: null, options: null }
        });
        this.headers.push({
            generic: { manage: 1, default: null, name: 'action', width: 11, change: null, click: this.onActionClick },
            caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.usersList.captions[8] },
            element: { type: 'button',
            colClass: 'center',
            itemClass: 'action',
            btnSaveText: this.le.usersList.popup.saveButton,
            btnDeleteText: this.le.usersList.popup.deleteButton,
            options: null
        }
        });
        

        this.listKey = 0;

        this.originalData = {
            card: {
                image: this.uc.image || '../../images/user3x-d.png',
                name: this.uc.firstName + " " + this.uc.lastName,
                email: this.uc.username,
                level: this.uc.userRole.toUpperCase(),
                logout: this.le.card.logout,
                edit: this.le.card.edit,
                addUser: this.le.addUser,
                usersList: this.le.usersList.buttonText,
                isSuperAdmin: this.uc.isSuperAdmin
            },
            registration: {
                name: this.uc.firstName,
                surname: this.uc.lastName,
                password: 'xxxxxxxxxxxxxxxxxxxx',
                confirm: 'xxxxxxxxxxxxxxxxxxxx',
                phone: this.uc.phone || "",
                email: this.uc.username,
                chkAdmin: this.uc.userRole == Roles.ADMIN,
                chkUser: this.uc.userRole == Roles.USER,
                chkReadonly: this.uc.userRole == Roles.READONLY,
                chkUserPro: this.uc.userRole == Roles.USERPRO,
                chkWarehouseAdmin: this.uc.userRole == Roles.WAREHOUSEADMIN,
                chkWarehouseUser: this.uc.userRole == Roles.WAREHOUSEUSER,   
                recoveryMail: ""
            },
            invoicing: {
                name: '',
                surname: '',
                businessName: '',
                address: '',
                city: '',
                province: '',
                zipCode: '',
                fiscalCode: '',
                phone: '',
                certEmail: '',
               // confirm: '',
                vatNumber: '',
                uniqueCode: '',
                adminEmail: ''
            },
            usersListPasswordFields: {
                password: 'xxxxxxxxxxxxxxxxxxxx',
                confirm: 'xxxxxxxxxxxxxxxxxxxx',
            }
        };
        this.backups = {};
        this.empties = {
            registration: {
                name: '',
                surname: '',
                password: '',
                confirm: '',
                phone: '',
                email: '',
                chkAdmin: false,
                chkUser: true,
                chkReadonly: false,
                chkuUserPro: false,
                chkWarehouseAdmin: false,
                chkWarehouseUser: false,
                recoveryMail: ""
            }
        };

      
        this.navigationParams = "";
        if (this.props.location.state && this.props.location.state.params)
            this.navigationParams = this.props.location.state.params;
        
        this.state = {
            data: this.originalData,
            jwtToken: this.uc.jwtToken,
            pageStyle: this.uc.userRole === Roles.ADMIN ? 0 : 1,
            modalType: 0,
            userModalType: 0,
            modalMsg: "",
            msgNumber: 0,
            isSuperAdmin: this.uc.isSuperAdmin,
            isCreatingUser: false,
            showUsersList: false,
            usersList: [],
            recoveryMailStatus: "notConfigured",
            recoveryMailStatusText: this.le.recoveryMail.notConfigured,
            originalRecoveryMail: "",
            passwordFocused: false,
            currentPasswordPopupOpen: false,
            sensitiveChangeLoading: false,
            pendingSensitiveChanges: null
        };
        
    }

    //#region Events

    loadRecoveryMail = () => {
        ajax(
            this,
            {
                method: "get",
                url: "/api/user/recovery-mail",
                headers: {
                    Authorization:
                        "Bearer " + this.state.jwtToken
                }
            },
            response => {
                const recoveryData = response.data || {};

                const recoveryMail =
                    recoveryData.pendingRecoveryMail ||
                    recoveryData.recoveryMail ||
                    "";

                const status =
                    recoveryData.status || "notConfigured";

                const statusText =
                    status === "verified"
                        ? this.le.recoveryMail.verified
                        : status === "pending"
                            ? this.le.recoveryMail.pending
                            : this.le.recoveryMail.notConfigured

                const newData =
                    myDeepCopy(this.state.data);

                newData.registration.recoveryMail =
                    recoveryMail;

                this.originalData.registration.recoveryMail =
                    recoveryMail;

                this.setState({
                    data: newData,
                    originalRecoveryMail: recoveryMail,
                    recoveryMailStatus: status,
                    recoveryMailStatusText: statusText
                });
            },
            () => {
                this.setState({
                    recoveryMailStatus: "notConfigured",
                    recoveryMailStatusText: this.le.recoveryMail.loadError
                });
            }
        );
    };

    componentDidMount() {
        try {
            this.props.loaderShow();
            ajax(this, { method: 'get', url: '/api/userprofile', headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
                response => {
                    Object.assign(this.originalData.invoicing, response.data.result.userBilling);
                    this.originalData.invoicing.confirm = this.originalData.invoicing.certEmail;
                    this.originalData = setEmptyStrings(this.originalData);
                    this.setState(
                        {
                            data: this.originalData
                        },
                        () => {
                            if (this.navigationParams === "NEW_USER") {
                                this.addUser();
                                this.navigationParams = "";
                            } else {
                                this.loadRecoveryMail();
                            }

                            this.props.loaderHide();
                        }
                    );
                },
                error => {
                    this.props.loaderHide();
                    this.setState({ modalType: 1, modalMsg: error.message });
                }
            );
            loadUsersList(this.uc.jwtToken,  usersList => {
                const transformedUsersList = usersList.map((user) => {
                    return {
                        user: {
                            ...user,
                            password: 'xxxxxxxxxxxxxxxxxxxx',
                            confirmPwd: 'xxxxxxxxxxxxxxxxxxxx',
                            originalPassword: 'xxxxxxxxxxxxxxxxxxxx',
                            originalConfirmPwd: 'xxxxxxxxxxxxxxxxxxxx',
                        },
                        originaUserData: {
                            ...user,
                            password: 'xxxxxxxxxxxxxxxxxxxx',
                            confirmPwd: 'xxxxxxxxxxxxxxxxxxxx',
                            originalPassword: 'xxxxxxxxxxxxxxxxxxxx',
                            originalConfirmPwd: 'xxxxxxxxxxxxxxxxxxxx',
                        }
                    }
                });
                this.setState({
                    usersList: transformedUsersList
                })
            },
            ko => { },
            this)
        }
        catch (e) {
            this.props.loaderHide();
        }

    }

    onFieldChange(ev, name, value, userId) {
        this.setState((prevState) => {
            const updatedUsersList = prevState.usersList.map((user) => {
              if (user.user.id === userId) {
                
                return { 
                    user: {
                        ...prevState.user,
                        ...user.user,
                        [name]: value,
                    },
                    originaUserData: {
                        ...user.originaUserData,
                    }
                   
                };
              }
              return user;
            });

            return { usersList: updatedUsersList };
          });
    }

    passwordChanged(jwtToken) {
        if (!jwtToken) {
            this.setState({
                modalType: 1,
                modalMsg: this.le.passwordChange.missingToken
            });
            return;
        }

        const updatedUserContext = {
            ...this.uc,
            jwtToken
        };

        if (!saveUserContext(updatedUserContext)) {
            this.setState({
                modalType: 1,
                modalMsg: this.le.passwordChange.sessionUpdateError
            });
            return;
        }

        this.uc = updatedUserContext;

        this.setState({
            jwtToken
        });
    }

    modifyUserList(userId) {
        let postData = {};
        const user = this.state.usersList.find(user => user.user.id === userId);
        const {
            user: userData,
            originaUserData,
        } = user;
        const {
            password: userPassword,
            confirmPwd: userConfirmPassword,
            originalPassword: userOriginalPassword,
            email: userEmail,
            name: userName,
            surname: userSurname,
            phone: userPhone,
            profileType: userProfileType
        } = userData;
        
        if (JSON.stringify(userData) !== JSON.stringify(originaUserData)) {
            let pwd = "";
            const passwordChanged = userPassword !== userOriginalPassword;

            if (passwordChanged) {
                if (userPassword !== userConfirmPassword) {
                    this.setState({
                        userModalType: 1,
                        modalMsg: "",
                        msgNumber: 1
                    });
                    return;
                }

                if (!isPasswordValid(userPassword)) {
                    this.setState({
                        userModalType: 1,
                        modalMsg: "",
                        msgNumber: 2
                    });
                    return;
                }

                pwd = userPassword;
            }

            let isAdmin = userProfileType === Roles.ADMIN;;
            let userSignUp = {};
            userSignUp.Id = userId;
            userSignUp.Email = userEmail;
            userSignUp.Password = pwd;
            userSignUp.ConfirmPwd = pwd;
            userSignUp.IsAdmin = isAdmin;
            userSignUp.Name = userName;
            userSignUp.Surname = userSurname;
            userSignUp.Phone = userPhone;
            userSignUp.ProfileType = userProfileType;
            postData.userSignUp = userSignUp;
        }


        if (!!postData.userSignUp) {
            ajax(this, { method: 'post', url: `/api/userprofile/post-profile`, headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: postData },
            response => {
                this.setState({
                    userModalType: 2, modalMsg: '', msgNumber: 0
                });
            },
            error => {
                this.setState({ userModalType: 1, modalMsg: error.message });
            }
         );
        }
    }

    deleteUserList(userId) {
        ajax(this, { method: 'post', url: 'api/userprofile/user-creds-organization-delete/' + userId, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                const users = this.state.usersList.filter(user => user.user.id !== userId);
                this.setState({
                        usersList: users,
                        userModalType: 2,
                        modalMsg: '',
                        msgNumber: 0
                    });
            },
            error => {
                this.setState({ userModalType: 1, modalMsg: error.message });
            }
        );
    }

    onActionClick(actionType, userId) {

        if(actionType === 'modify') {
        

            this.modifyUserList(userId)
        } else {
            this.deleteUserList(userId)
        }
    }

    changeValue(ev, who, val, fieldId) {
        let newData = JSON.parse(JSON.stringify(this.state.data));
        const sections = this.configs.sections;
        const section = sections[who[0]];
        const column = section.columns[who[1]];
        const field = fieldId
            ? column.items.find(item => item.id === fieldId)
            : column.items[who[2]];

        if (!field) {
            return;
        }

        const first = section.id;
        const second = field.id;

        if (field.type === 'radio') {
            let group = field.group;
            section.columns.forEach(function (col) {
                col.items.forEach(function (item) {
                    if (item.type === 'radio' && item.group === group) {
                        newData[first][item.id] = false;
                    }
                });
            });
        }

        newData[first][second] = val;
        this.setState({ data: newData });
    }

    renderPasswordTooltip() {
        const currentPassword = this.state.data.registration.password;

        const password = currentPassword === this.originalData.registration.password
                ? ""
                : currentPassword;

        return (
            <PasswordPolicyTooltip
                password={password}
            />
        );
    }

    getSensitiveChanges() {
        if (this.state.isCreatingUser) {
            return {
                passwordChanged: false,
                recoveryMailChanged: false,
                recoveryMail: ""
            };
        }

        const registration =
            this.state.data.registration;

        const passwordChanged =
            registration.password !==
            this.originalData.registration.password ||
            registration.confirm !==
            this.originalData.registration.confirm;

        const recoveryMail =
            (registration.recoveryMail || "").trim();

        const originalRecoveryMail =
            (this.state.originalRecoveryMail || "").trim();

        return {
            passwordChanged,
            recoveryMailChanged:
                recoveryMail.toLowerCase() !==
                originalRecoveryMail.toLowerCase(),
            recoveryMail
        };
    }

    applyRecoveryMailChange = (
        currentPassword,
        changes,
        onSuccess,
        onError
    ) => {
        if (!changes.recoveryMailChanged) {
            onSuccess();
            return;
        }

        const removing =
            !changes.recoveryMail;

        ajax(
            this,
            {
                method: "post",
                url: removing
                    ? "/api/user/recovery-mail/remove"
                    : "/api/user/recovery-mail/request-change",
                headers: {
                    Authorization:
                        "Bearer " + this.state.jwtToken
                },
                data: removing
                    ? {
                        currentPassword
                    }
                    : {
                        currentPassword,
                        recoveryMail:
                            changes.recoveryMail
                    }
            },
            () => {
                const newData =
                    myDeepCopy(this.state.data);

                newData.registration.recoveryMail =
                    changes.recoveryMail;

                this.originalData.registration.recoveryMail =
                    changes.recoveryMail;

                this.setState(
                    {
                        data: newData,
                        originalRecoveryMail:
                            changes.recoveryMail,
                        recoveryMailStatus: removing
                            ? "notConfigured"
                            : "pending",
                        recoveryMailStatusText: removing
                            ? this.le.recoveryMail.notConfigured
                            : this.le.recoveryMail.pending
                    },
                    onSuccess
                );
            },
            () => {
                onError(
                    removing
                        ? this.le.recoveryMail.removeError
                        : this.le.recoveryMail.saveError
                );
            }
        );
    };

    applyPasswordChange = (
        currentPassword,
        changes,
        onSuccess,
        onError
    ) => {
        if (!changes.passwordChanged) {
            onSuccess();
            return;
        }

        const registration =
            this.state.data.registration;

        ajax(
            this,
            {
                method: "post",
                url: "/api/user/change-pwd",
                headers: {
                    Authorization:
                        "Bearer " + this.state.jwtToken
                },
                data: {
                    currentPassword,
                    password: registration.password,
                    confirmPassword:
                        registration.confirm
                }
            },
            response => {
                const jwtToken =
                    response.data &&
                    response.data.result &&
                    response.data.result.jwtToken;

                if (!jwtToken) {
                    onError(this.le.passwordChange.missingToken);
                    return;
                }

                const updatedUserContext = {
                    ...this.uc,
                    jwtToken
                };

                if (!saveUserContext(updatedUserContext)) {
                    onError(this.le.passwordChange.sessionUpdateError);
                    return;
                }

                this.uc = updatedUserContext;

                const passwordPlaceholder = "xxxxxxxxxxxxxxxxxxxx";

                const newData =
                    myDeepCopy(this.state.data);

                newData.registration.password =
                    passwordPlaceholder;

                newData.registration.confirm =
                    passwordPlaceholder;

                this.originalData.registration.password =
                    passwordPlaceholder;

                this.originalData.registration.confirm =
                    passwordPlaceholder;

                this.setState(
                    {
                        data: newData,
                        jwtToken,
                        passwordFocused: false
                    },
                    onSuccess
                );
            },
            error => {
                const errorMessage = error &&
                        error.errorCode === 101
                            ? this.le.passwordChange.sameAsCurrentError
                            : this.le.passwordChange.failure;
                onError(errorMessage);
            }
        );
    };

    confirmSensitiveChanges = currentPassword => {
        const changes =
            this.state.pendingSensitiveChanges;

        if (!changes) {
            return;
        }

        this.setState({
            sensitiveChangeLoading: true
        });

        const fail = message => {
            this.setState({
                currentPasswordPopupOpen: false,
                sensitiveChangeLoading: false,
                pendingSensitiveChanges: null,
                modalType: 1,
                modalMsg: message
            });
        };

        const complete = () => {
            this.setState(
                {
                    currentPasswordPopupOpen: false,
                    sensitiveChangeLoading: false,
                    pendingSensitiveChanges: null,
                    modalType: 2,
                    modalMsg: ""
                },
                () => {
                    /*
                     * Salva eventuali modifiche anagrafiche.
                     * Le modifiche sensibili non risultano più
                     * differenti dagli originali.
                     */
                    this.saveClick();
                }
            );
        };

        /*
         * La recovery mail deve essere elaborata prima:
         * il cambio password invalida la password corrente.
         */
        this.applyRecoveryMailChange(
            currentPassword,
            changes,
            () => {
                this.applyPasswordChange(
                    currentPassword,
                    changes,
                    complete,
                    fail
                );
            },
            fail
        );
    };

    saveClick(ev) {

        let validationData = [];
        this.configs.sections.forEach(sec => {
            if (sec.id == "invoicing" && this.state.pageStyle != 0)
                return;
            let src = this.state.data[sec.id];
            sec.columns.forEach(col => {
                col.items.forEach(itm => {
                    if (!this.state.isCreatingUser && sec.id === "registration" && (itm.id === "password" || itm.id === "confirm"))
                    {
                        return;
                    }

                    if (itm.mandatory)
                        validationData.push({
                            fieldObject: itm,
                            fieldName: itm.id,
                            fieldValue: src[itm.id],
                            fieldError: 'error',
                            validate: emptyValidation
                        });
                }, this);
            }, this);
        }, this);

        if (!validate(validationData)) {
            this.props.popupErrorMessage(this.le.messages[0].messages[3]);
            return;
        }

        const sensitiveChanges =
            this.getSensitiveChanges();

        if (sensitiveChanges.passwordChanged) {
            const password =
                this.state.data.registration.password;

            const confirmPassword =
                this.state.data.registration.confirm;

            if (password !== confirmPassword) {
                this.setState({
                    modalType: 1,
                    modalMsg: "",
                    msgNumber: 1
                });
                return;
            }

            if (!isPasswordValid(password)) {
                this.setState({
                    modalType: 1,
                    modalMsg: "",
                    msgNumber: 2
                });
                return;
            }
        }

        if (
            sensitiveChanges.passwordChanged ||
            sensitiveChanges.recoveryMailChanged
        ) {
            this.setState({
                currentPasswordPopupOpen: true,
                pendingSensitiveChanges:
                    sensitiveChanges,
                modalType: 0,
                modalMsg: ""
            });

            return;
        }


        let postData = {};

        if (JSON.stringify(this.state.data.invoicing) !== JSON.stringify(this.originalData.invoicing)) {
            if (this.state.data.invoicing.certEmail !== this.state.data.invoicing.confirm) {
                this.setState({ modalType: 1, modalMsg: '', msgNumber: 0 });
                return;
            }
            postData.userBilling = this.state.data.invoicing;
        }

        if (JSON.stringify(this.state.data.registration) !== JSON.stringify(this.originalData.registration)) {

            let isAdmin = !!this.state.data.registration.chkAdmin;
            let userSignUp = {};
            userSignUp.Email = this.state.data.registration.email;
            userSignUp.IsAdmin = isAdmin;
            userSignUp.Name = this.state.data.registration.name;
            userSignUp.Surname = this.state.data.registration.surname;
            userSignUp.Phone = this.state.data.registration.phone;

            if (this.state.isCreatingUser) {
                const pwd = this.state.data.registration.password;
                const confirmPwd = this.state.data.registration.confirm;

                if (pwd !== confirmPwd) {
                    this.setState({
                        modalType: 1,
                        modalMsg: "",
                        msgNumber: 1
                    });
                    return;
                }

                if (!isPasswordValid(pwd)) {
                    this.setState({
                        modalType: 1,
                        modalMsg: "",
                        msgNumber: 2
                    });
                    return;
                }

                userSignUp.Password = pwd;
                userSignUp.ConfirmPwd = confirmPwd;
            }

            this.addUserProfileType(userSignUp);
            
            postData.userSignUp = userSignUp;
            //console.log(postData, "postData")
        }

        if (!!postData.userSignUp || !!postData.userBilling) {
            ajax(this, { method: 'post', url: '/api/userprofile/post-profile', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: postData },
                response => {
                    if (postData.userSignUp && this.uc.username == postData.userSignUp.Email) {
                        if (!!postData.userBilling) {
                            this.originalData.invoicing = myDeepCopy(this.state.data.invoicing);
                            this.uc.invoicing = true;
                            saveUserContext(this.uc);
                            this.props.setInvoicing(true);
                        }
                        if (!!postData.userSignUp) {
                            this.originalData.registration = myDeepCopy(this.state.data.registration);
                            this.uc.firstName = postData.userSignUp.Name;
                            this.uc.lastName = postData.userSignUp.Surname;
                            this.uc.phone = postData.userSignUp.Phone;
                            this.uc.username = postData.userSignUp.Email;
                            this.uc.userRole = postData.userSignUp.ProfileType;
                            saveUserContext(this.uc);
                        }
                    }

                    if (this.state.isCreatingUser) {
                        const newData = JSON.parse(JSON.stringify(this.state.data));

                        newData.registration =
                            Object.assign(
                                {},
                                this.backups.registration
                            );

                        this.changeRoleAllowed = false;

                        this.setState({
                            data: newData,
                            pageStyle: 0,
                            isCreatingUser: false,
                            modalType: 2,
                            modalMsg: "",
                            msgNumber: 0
                        }, () => {
                            this.loadRecoveryMail();
                        });


                        return;
                    }

                    this.setState({ modalType: 2, modalMsg: '', msgNumber: 0 });
                },
                error => {
                    this.setState({ modalType: 1, modalMsg: error.message });
                }
            );
        }
    }

    closeModal(ev) {
        this.setState({ modalType: 0, modalMsg: "" });
    }

    addUser(ev) {
        let newData = JSON.parse(JSON.stringify(this.state.data));
        this.backups.registration = Object.assign({}, newData.registration);
        newData.registration = Object.assign({}, this.empties.registration);

        this.configs.sections[0].columns[0].items[5].disabled = false;
        this.changeRoleAllowed = true;
        

        this.setState({
            data: newData,
            pageStyle: 1,
            isCreatingUser: true
        });
    }

    toggleUsersListHandler() {
        this.setState((prevState) => {
            return {
                showUsersList: !prevState.showUsersList
            }
        })
    }


    addUserProfileType (userSignUp) {
        let isAdmin = !!this.state.data.registration.chkAdmin;
        let isUser = !!this.state.data.registration.chkUser;
        let isReadonly = !!this.state.data.registration.chkReadonly;
        let isUserPro = !!this.state.data.registration.chkUserPro;

        if (isAdmin) {
            userSignUp.ProfileType = Roles.ADMIN;
        } else if (isUser) {
            userSignUp.ProfileType = Roles.USER
        } else if (isReadonly) {
            userSignUp.ProfileType = Roles.READONLY
        } else if (isUserPro) {
            userSignUp.ProfileType = Roles.USERPRO
        }
        return userSignUp;
    }

    //createUser() {

    //    const password = this.state.data.registration.password;
    //    const confirmPassword = this.state.data.registration.confirm;

    //    if (password !== confirmPassword) {
    //        this.setState({
    //            modalType: 1,
    //            modalMsg: "",
    //            msgNumber: 1
    //        });
    //        return;
    //    }

    //    if (!isPasswordValid(password)) {
    //        this.setState({
    //            modalType: 1,
    //            modalMsg: "",
    //            msgNumber: 2
    //        });
    //        return;
    //    }

    //    let userSignUp = {};
    //    let isAdmin = !!this.state.data.registration.chkAdmin;
    //    userSignUp.email = this.state.data.registration.email;
    //    userSignUp.password = password;
    //    userSignUp.confirmPwd = confirmPassword;
    //    userSignUp.isAdmin = isAdmin;
    //    userSignUp.name = this.state.data.registration.name;
    //    userSignUp.surname = this.state.data.registration.surname;
    //    userSignUp.phone = this.state.data.registration.phone;
        
    //    this.addUserProfileType(userSignUp);
    
    //    ajax(this, { method: 'post', url: '/api/user', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: userSignUp },
    //        response => {
    //            let newData = JSON.parse(JSON.stringify(this.state.data));
    //            newData.registration = Object.assign({}, this.backups.registration);
    //            this.changeRoleAllowed = false;

    //            this.setState({
    //                data: newData,
    //                pageStyle: 0,
    //                modalType: 2,
    //                modalMsg: "",
    //                msgNumber: 0,
    //                isCreatingUser: false
    //            });
    //        },
    //        error => {
    //            this.setState({ modalType: 1, modalMsg: error.message });
    //        }
    //    );
    //}

    cancelCreateUser() {
        let newData = JSON.parse(JSON.stringify(this.state.data));
        newData.registration = Object.assign({}, this.backups.registration);
        this.setState({
            data: newData,
            pageStyle: 0,
            modalType: 0,
            isCreatingUser: false
        }, () => {
            this.loadRecoveryMail();
        });
    }

    //#endregion Events

    render() {
        const card = Object.assign({}, this.configs.card, this.state.data.card);
        const sectionsData = myDeepCopy(this.configs.sections);
        if (this.state.pageStyle > 0) sectionsData.splice(1, 1);
        sectionsData.forEach(section => {
            section.columns.forEach(column => {
                if (
                    this.state.isCreatingUser &&
                    section.id === "registration"
                ) {
                    column.items =
                        column.items.filter(
                            item =>
                                item.id !== "recoveryMail"
                        );
                }

                column.items.forEach(item => {
                    if (
                        item.type === "radio" &&
                        !this.changeRoleAllowed
                    ) {
                        item.disabled = true;
                    }

                    item.value =
                        this.state.data[section.id][item.id];

                    if (
                        section.id === "registration" &&
                        item.id === "password"
                    ) {
                        item.extraContent =
                            this.state.passwordFocused
                                ? this.renderPasswordTooltip()
                                : null;
                    }

                    if (
                        section.id === "registration" &&
                        item.id === "recoveryMail"
                    ) {
                        item.helperText =
                            this.state.recoveryMailStatusText;

                        item.helperClass =
                            "recovery-status " +
                            this.state.recoveryMailStatus;
                    }
                });
            });
        });
        const sections = sectionsData.map((el, idx) => (
            <InputSection
                key={'sec-' + idx}
                section={idx}
                data={el}
                onChange={(ev, who, val) =>
                    this.changeValue(
                        ev,
                        who,
                        val,
                        el.columns[who[1]].items[who[2]].id
                    )
                }
            />
        ));

        let modal = null;
        let modalUser = null;
        if (this.state.modalType > 0) {
            const msg = this.le.messages[this.state.modalType - 1];
            modal = <UIMessageBox type="info" title={msg.captions} message={[this.state.modalMsg || msg.messages[this.state.msgNumber]]}>
                <UIButton text="Ok" onClick={(ev) => (this.setState({modalType: 0}))} />
            </UIMessageBox>;
                }


        if (this.state.userModalType > 0) {
            const msg = this.le.messages[this.state.userModalType - 1];
            modalUser = <UIMessageBox type="info" title={msg.captions} message={[this.state.modalMsg || msg.messages[this.state.msgNumber]]}>
                <UIButton text="Ok" onClick={(ev) => (this.setState({userModalType: 0}))} />
            </UIMessageBox>;
        }

                return (
            <div className="page-userprofile">
                <PageTitle icon="../images/user3x-d.png" title={Languages.getSection('Main').menuLabels.profile}/>
                <div className="page-content">
                    <UserCard data={card} handlers={{
                                onEdit: null,
                                onAddUser: this.uc.userRole == 'admin' ? this.addUser : null,
                         onShowUsersList: this.toggleUsersListHandler
                        }
                    }
                    logoutClick={this.props.logoutClick}/>
                    <div className="user-profile-inputs">
                        {sections}
                    </div>
                </div>
                {modal}

                {this.state.currentPasswordPopupOpen &&
                    <CurrentPasswordPopup
                        loading={this.state.sensitiveChangeLoading}
                        title={this.le.passwordChange.sensitiveChangesTitle}
                        message={this.le.passwordChange.sensitiveChangesMessage}
                        onConfirm={this.confirmSensitiveChanges}
                        onCancel={() => {
                            if (!this.state.sensitiveChangeLoading)
                            {
                                this.setState({
                                    currentPasswordPopupOpen: false,
                                    pendingSensitiveChanges: null
                                });
                            }
                        }}
                    />
                }

                {this.state.showUsersList &&
                    <UIPopup
                        className="users-lists-popup"
                        title={this.le.usersList.popup.title}
                        buttons={[
                        <UIButton key="btn-1" className="" text={this.le.usersList.popup.cancelButton} onClick={this.toggleUsersListHandler} />,
                        ]}
                    >
                        <div>
                            <UsersList 
                                headers={this.headers}
                                entries={this.state.usersList}
                                recoveryMailTexts={this.le.recoveryMail}
                            />
                            
                        </div>
                    </UIPopup>
                }

                {modalUser}
            </div>
        );
    }
}

